import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/App";
import { initLangAttribute } from "@/design";
import i18n from "@/i18n";
import { initSentry } from "@/lib/sentry";
import { initWebVitals } from "@/lib/web-vitals";
import "@/styles/globals.css";

initSentry();
initWebVitals();
initLangAttribute();

const storedLang = localStorage.getItem("atlas.lang");
if (storedLang === "en" || storedLang === "th") {
  void i18n.changeLanguage(storedLang);
}

async function enableMocking(): Promise<void> {
  if (!import.meta.env.DEV || import.meta.env.PUBLIC_ENABLE_MSW !== "true") return;
  const { startMocks } = await import("@/mocks/browser");
  await startMocks();
}

void enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
